import { combineReducers } from "@reduxjs/toolkit";
import briefReducer from "../slices/brief";
import bulkBriefsReducer from "../slices/bulkBriefs";
import eeatReducer from "../slices/eeat";
import humanizeReducer from "../slices/humanize";
import keywordSuggestionsReducer from "../slices/keywordSuggestions";
import optimizeContentReducer from "../slices/optimizeContent";
import projectsReducer from "../slices/projects";
import seoMissionsReducer from "../slices/seoMissions";
import suggestionsReducer from "../slices/suggestions";
import systemReducer from "../slices/system";

export const rootReducer = combineReducers({
  brief: briefReducer,
  bulkBriefs: bulkBriefsReducer,
  eeat: eeatReducer,
  system: systemReducer,
  suggestions: suggestionsReducer,
  keywordSuggestions: keywordSuggestionsReducer,
  projects: projectsReducer,
  seoMissions: seoMissionsReducer,
  optimizeContent: optimizeContentReducer,
  humanize: humanizeReducer,
});
